export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 4.5a1 1 0 011 1v13a1 1 0 01-1 1H3a1 1 0 01-1-1v-13a1 1 0 011-1h18zm-8.386 9.29c-.36.28-.867.28-1.228 0L4 8.043V17.5h16V8.044l-7.386 5.745zM12 11.731L18.729 6.5H5.27L12 11.732z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};